import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import InputDatoProdotto from "../../../modificaProdotti/elementiPagina/InputDatoProdotto";
import _ from "lodash";
import apiUrl from "../../../Apiurl";
import InputBoolean from "../../../modificaProdotti/elementiPagina/InputBoolean";
import ListaAssocia from "../../componenti/ListaAssocia";
import RiquadrinoFornitore from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/RiquadrinoFornitore";

function ModificaContatti({
    contatto,
    setContatto,
    utente,
    mobile
}) {


    const {
        buttonClassesRed,
        buttonClassesGreen,
        classiTastoSblocco,
        inputClassesNOW,
        riquadroClassesRed,
    } = stilePulsanti

    let classDivPrincipale = "fixed-l w-100-l sfondoColChiaro h-100 colonnaTuttaPagina-ns flex justify-center"


    ///// HOOKS //////////////////

    const [contattoTemp, setContattoTemp] = useState(contatto);
    const [salvato, setSalvato] = useState(true);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [alert, setAlert] = useState("");
    const [alertSalvataggio, setAlertSalvataggio] = useState(false);


    ///// FUNZIONI ///////////////

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);

    

    const handleChange = async function (evt) {
        setSalvato(false);
        const value = evt.target.value;
        try {
            if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
                const update = _.set(_.cloneDeep(contattoTemp), evt.target.name, value) // METODO RESOURCE EXPENSIVE
                setContattoTemp(update)
            } else if (!evt.target.name.includes(".") && !evt.target.name.includes("[")) {
                setContattoTemp({
                    ...contattoTemp,
                    [evt.target.name]: value
                });
            } else {
                setAlert("Errore cambio dato")
            }
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato nestato: " + err)
            throw err;
        }
    }

    async function salvaProdotto(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                contatto: contattoTemp
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaContatto", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setAlertSalvataggio(false)
                        setSalvato(true);
                        setContatto(false);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    async function salvaProdottoSenzaChiudere(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                contatto: contattoTemp
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaContatto", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setContattoTemp({
                            ...contattoTemp,
                            id: resp.data.insertId
                        });
                        setAlertSalvataggio(false)
                        setSalvato(true);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    function chiudiSenzaSalvare(e) {
        e.preventDefault()
        setContatto(false)
    }

    //////////// RIQUADRINI DA PASSARE A LISTE ASSOCIAZIONI

    function listaRiquadriFornitori (el,funzioneRimuovi) {
        return(<RiquadrinoFornitore  
            elemento={el}
            rimuoviAssociazione={funzioneRimuovi}
            scelto={true}
        />)
    }

    



    /////////////////////////////////////////// COLONNE /////////////////////////////////////

    function riquadroSalvataggio() {
        return (
            <div>
                {alertSalvataggio && <div className={riquadroClassesRed + " mb2"}>{alertSalvataggio}</div>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdottoSenzaChiudere}>Salva</button>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdotto}>Salva e chiudi</button>}
                {!salvato && <button className={buttonClassesRed + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi senza salvare</button>}
                {salvato && <button className={buttonClassesGreen + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi</button>}
                {alert && <h3 className="tastoRosso white">{alert}</h3>}
            </div>
        )
    }

    function riquadroDatiContatto() {
        return (
            <div className="">
                <h2>{contattoTemp.nome}</h2>
                <div className="mt3 mb3 flex flex-wrap">
                    <div className="mb4 flex flex-wrap">
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"rappresentante"}
                        valoreDatoBooleano={contattoTemp.rappresentante}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"Rappresentante"}
                        testoSe0={"Rappresentante"}
                        flexWidth={"w-50"}
                        icon1={"hail"}
                        icon0={"hail"}
                        colIcon1={"scrittaColAltScuro"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"customer"}
                        valoreDatoBooleano={contattoTemp.customer}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"Customer Service"}
                        testoSe0={"Customer Service"}
                        flexWidth={"w-50"}
                        icon1={"support_agent"}
                        icon0={"support_agent"}
                        colIcon1={"scrittaColAltScuro"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"warranty"}
                        valoreDatoBooleano={contattoTemp.warranty}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"Warranties"}
                        testoSe0={"Warranties"}
                        flexWidth={"w-50"}
                        icon1={"hardware"}
                        icon0={"hardware"}
                        colIcon1={"scrittaColAltScuro"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"immagini"}
                        valoreDatoBooleano={contattoTemp.immagini}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"Immagini"}
                        testoSe0={"Immagini"}
                        flexWidth={"w-50"}
                        icon1={"image"}
                        icon0={"image"}
                        colIcon1={"scrittaColAltScuro"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"ean"}
                        valoreDatoBooleano={contattoTemp.ean}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"EAN"}
                        testoSe0={"EAN"}
                        flexWidth={"w-50"}
                        icon1={"list"}
                        icon0={"list"}
                        colIcon1={"scrittaColAltScuro"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    <InputBoolean
                        permessiAPIutente={utente.permessiAPI}
                        permessiAPIRichiesti={"update:database"}
                        oggettoInteroDaModificare={contattoTemp}
                        setOggetto={setContattoTemp}
                        setSalvato={setSalvato}
                        datoBooleano={"obsoleto"}
                        valoreDatoBooleano={contattoTemp.obsoleto}
                        classnameSeDato1={"colAltChiaro"}
                        classnameSeDato0={"light-silver"}
                        testoSe1={"Obsoleto"}
                        testoSe0={"Obsoleto"}
                        flexWidth={"w-50"}
                        icon1={"no_accounts"}
                        icon0={"no_accounts"}
                        colIcon1={"red"}
                        colIcon0={"moon-gray"}
                        nonCentrare={true}
                    />
                    </div>
                    <InputDatoProdotto
                    inputLabel="nome"
                    datoName='nome'
                    datoId="nome"
                    datoValue={contattoTemp.nome ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="eMail"
                    datoName='mail'
                    datoId="mail"
                    datoValue={contattoTemp.mail ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cc"
                    datoName='cc'
                    datoId="cc"
                    datoValue={contattoTemp.cc ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cell"
                    datoName='cell'
                    datoId="cell"
                    datoValue={contattoTemp.cell ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cell2"
                    datoName='cell2'
                    datoId="cell2"
                    datoValue={contattoTemp.cell2 ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                </div>
                <label for="note" className="w-100 mt3">Note</label>
                        {utente.permessiAPI["update:database"]
                        ? <textarea
                            type="text"
                            rows="5"
                            id="note"
                            name={'note'}
                            value={contattoTemp.note ?? ""}
                            onChange={handleChange}
                            className={inputClassesNOW + " w-100"} />
                        : <p>{contattoTemp.note ?? ""}</p>
                        }
                <div>ID {contattoTemp.id}</div>
            </div>
        )
    }

    function associaAFornitore() {
        return(
            <div>
                <ListaAssocia 
                    idElemento1={contattoTemp.id}
                    colonnaID1={"id1"}
                    colonnaID2={"id2"}
                    tipoCong={"CF"}
                    tabellaElemento2={"DAM_Fornitori"}
                    riquadroElemento2={listaRiquadriFornitori}
                    height={100}
                    titolo={"Fornitori collegati"}
                    token={token}
                    querySpecifica={"/anagrafiche/ricFornitoreDaIDcontatto"}
                    utente={utente}
                />
            </div>
        )
    }


    //////////////////////////////////////////////////////////////////////////////////


    ///// PAGINA


    return (

        <div className={classDivPrincipale}>
            <div className="w-50 ma3-ns br4-ns sfondoBiancoTema flex flex-wrap h-100 h-97-ns">
                <div className="w-100 flex flex-wrap h-100">
                    <div className="w-50 dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns datiOrdine">
                        <div className="colonna85vh sezioneConScroll">
                            {riquadroSalvataggio()}
                            {riquadroDatiContatto()}
                        </div>
                    </div>
                    <div className="w-50 dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns statoENote bl-ns bordoColAlt">
                        <div className="colonna85vh pr3">
                                {contattoTemp.id ? associaAFornitore() : <p>Devi salvare il contatto prima di associare il fornitore</p>}
                        </div>
                    </div>
                </div>                
            </div>
        </div>

    )
}

export default ModificaContatti;



